import { useState } from "react";

/* ── Logo ── */
import EnergyLogo from "../../assets/images/header/logo.png";

/* ── Social Icons ── */
import SpotifyIcon   from "../../assets/images/header/spotify.svg";
import YoutubeIcon   from "../../assets/images/header/youtube.svg";
import InstagramIcon from "../../assets/images/header/instagram.svg";
import AppleIcon     from "../../assets/images/header/apple.svg";

const NAV_LINKS = [
  { label: "Energizing India",  path: "/",                   dropdown: false },
  { label: "About Us",          path: "/about-us",           dropdown: false },
  { label: "Our Team",          path: "/our-team",           dropdown: false },
  { label: "Blog",              path: "/blog",               dropdown: false },
  { label: "Conversations",     path: "/conversations",      dropdown: true  },
  { label: "Behind the Scenes", path: "/behind-the-scenes",  dropdown: false },
  { label: "Contact Us",        path: "/contact",         dropdown: false },
];

const DROPDOWN_ITEMS = [
   { label: "Conversations",        path: "/conversations"    },
  { label: "Deep Dive",        path: "/all-episodes/"    },
  { label: "Watts Happening",  path: "/watts-happening/" },
  { label: "Editorial",        path: "/"                 },
  { label: "1.5 Diaries",      path: "/"                 },
];

const SOCIAL_LINKS = [
  { icon: SpotifyIcon,   alt: "Spotify",        href: "https://open.spotify.com/show/31CpjZm9DyfCR7sstBZlIf" },
  { icon: YoutubeIcon,   alt: "YouTube",        href: "https://www.youtube.com/@EnergizingIndiaPodcast" },
  { icon: InstagramIcon, alt: "Instagram",      href: "https://www.instagram.com/energizingindia/" },
  { icon: AppleIcon,     alt: "Apple Podcasts", href: "https://podcasts.apple.com/in/podcast/energizing-india-podcast/id1530917254" },
];

const isActive = (link) => {
  const p = window.location.pathname;
  if (link.dropdown) {
    return DROPDOWN_ITEMS.some((d) => d.path !== "/" && p.startsWith(d.path));
  }
  if (link.path === "/") return p === "/";
  return p.startsWith(link.path);
};

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap');

  .en-nav *, .en-nav *::before, .en-nav *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .en-nav {
    font-family: 'Roboto', sans-serif;
    background: #1a1a1a;
    position: sticky;
    top: 0;
    z-index: 999;
    width: 100%;
    padding:24px 0px;
  }

  .en-nav__inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0px 0px;
    height: 92px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .en-nav__logo {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    text-decoration: none;
  }

  .en-nav__logo img {
    height: 92px;
    width: auto;
    object-fit: contain;
    display: block;
  }

  .en-nav__links {
    display: flex;
    align-items: center;
    list-style: none;
    gap: 30px;
    flex: 1;
    justify-content: center;
    padding: 0 16px;
  }

  .en-nav__links li {
    position: relative;
  }

  .en-nav__links li a {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    text-decoration: none;
    padding: 0px 0px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 5px;
    letter-spacing: 0.1px;
    transition: color 0.2s ease;
    border-radius: 4px;
  }

  .en-nav__links li a:hover { color: #743FAC; }

  .en-nav__links li.en-nav__active > a { color: #743FAC; }
  .en-nav__links li.en-nav__active .en-nav__chevron { color: #743FAC; }

  .en-nav__chevron {
    width: 10px;
    height: 5px;
    flex-shrink: 0;
    color: #FFFFFF;
    transition: transform 0.2s ease;
  }

  .en-nav__links li.open .en-nav__chevron { transform: rotate(180deg); }
  .en-nav__links li:hover .en-nav__chevron { transform: rotate(180deg); }

  /* ── DROPDOWN ── */
  .en-nav__dropdown {
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 100%;
    left: 80%;
    transform: translateX(-50%);
    padding-top: 12px;
    background: transparent;
    min-width: 200px;
    list-style: none;
    z-index: 1000;
    transition: opacity 0.25s ease, visibility 0.25s ease;
  }

  .en-nav__dropdown::before {
    content: '';
    display: block;
    height: 12px;
  }

  .en-nav__dropdown-inner {
    background: #1a1a1a;
    border-top: 2px solid #743FAC;
    border-radius: 0px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0,0,0,0.6);
  }

  .en-nav__links li.open .en-nav__dropdown,
  .en-nav__links li:hover .en-nav__dropdown {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }

  .en-nav__dropdown li a {
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    padding: 14px 19px;
    display: block;
    white-space: nowrap;
    border-radius: 0;
    border-bottom: 1px solid #2F2F2F;
    margin:0px 8px;
  }

  .en-nav__dropdown li:last-child a { border-bottom: none; }

  .en-nav__dropdown li a:hover { background: #242424; color: #ffffff; }

  .en-nav__dropdown li a.en-nav__dropdown-active { color: #743FAC; }

  /* ── SOCIAL ICONS ── */
  .en-nav__socials {
    display: flex;
    align-items: center;
    gap: 14px;
    flex-shrink: 0;
  }

  .en-nav__social-btn {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #7c3aed;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    transition: background 0.2s ease, transform 0.15s ease;
    cursor: pointer;
    flex-shrink: 0;
  }

  .en-nav__social-btn:hover { background: #6d28d9; transform: scale(1.08); }

  .en-nav__social-btn svg {
    width: 17px;
    height: 17px;
    object-fit: contain;
    filter: brightness(0) invert(1);
    display: block;
  }

  /* ── HAMBURGER ── */
  .en-nav__hamburger {
    display: none;
    flex-direction: column;
    gap: 5px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    flex-shrink: 0;
  }

  .en-nav__hamburger span {
    display: block;
    width: 24px;
    height: 2px;
    background: #cccccc;
    border-radius: 2px;
    transition: all 0.25s ease;
  }

  .en-nav__hamburger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
  .en-nav__hamburger.open span:nth-child(2) { opacity: 0; }
  .en-nav__hamburger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

  /* ── DRAWER HR DIVIDER ── */
  .en-nav__divider {
    display: none;
    border: none;
    border-top: 1px solid #575757;
    margin: 0 20px;
  }

  @media (max-width: 768px) {

    .en-nav__hamburger { display: flex; }

    .en-nav__inner {
      position: relative;
      z-index: 999;
      padding: 0px 32px;
      overflow: hidden;
    }

    .en-nav--open .en-nav__inner {
      overflow: visible;
    }

    .en-nav__logo { order: 1; }
    .en-nav__socials { order: 2; margin-left: 0px; }
    .en-nav__hamburger { order: 3; margin-left: 16px; }

    /* ── DRAWER ── */
    .en-nav__links {
      display: flex;
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: #1a1a1a;
      flex-direction: column;
      align-items: stretch;
      padding: 0 0 24px 0;
      gap: 0;
      z-index: 998;
      // border-top: 1px solid #2a2a2a;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.35s ease;
      list-style: none;
      order: 4;
    }

    .en-nav__links.open {
      max-height: 629px;
      overflow-y: auto;
      overflow-x: visible;
    }

    .en-nav__links > li {
      width: 100%;
      border-bottom: none;
    }

    .en-nav__divider { display: block; }

    .en-nav__links > li > a {
      width: 100%;
      padding: 18px 24px;
      font-size: 16px;
      font-weight: 700;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .en-nav__links li.en-nav__active > a { color: #743FAC; }

    .en-nav__chevron { width: 12px; height: 7px; margin-left: auto; }

    /* ── MOBILE DROPDOWN ── */
    .en-nav__links li:hover .en-nav__dropdown { display: none; }
    .en-nav__links li.open .en-nav__dropdown { display: block; }

    .en-nav__dropdown {
      display: none;
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
      position: static;
      transform: none;
      padding: 0;
      min-width: unset;
      width: 100%;
      background: #1a1a1a;
      box-shadow: none;
      border: none;
    }

    .en-nav__dropdown::before { display: none; }

    .en-nav__dropdown-inner {
      background: transparent;
      border-top: none;
      border-radius: 0;
      box-shadow: none;
    }

    .en-nav__dropdown li { border-bottom: none; }
    .en-nav__dropdown li:last-child { border-bottom: none; }

    .en-nav__dropdown li a {
      font-size: 15px;
      font-weight: 400;
      color: #ffffff;
      padding: 16px 24px 16px 48px;
      margin: 0;
      white-space: normal;
      background: transparent;
      border-bottom: 1px solid #575757;
      margin:0 20px;
      border-radius: 0;
      display: block;
    }
      .en-nav__dropdown li:first-child a { border-top:1px solid #575757; }

    .en-nav__dropdown li a:hover { color: #ffffff; background: transparent; }
    .en-nav__dropdown li a.en-nav__dropdown-active { color: #743FAC; }

    .en-nav__hamburger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
    .en-nav__hamburger.open span:nth-child(2) { opacity: 0; }
    .en-nav__hamburger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }
    
  }

  @media (max-width: 480px) {
    .en-nav__social-btn { width: 26px; height: 26px; background:none;}
        .en-nav__inner { gap:0px;padding: 0 34px 0 44px; }
.en-nav { padding: 0px 0px 0px;}
    .en-nav__social-btn img { width: 26px; height: 26px; }
    .en-nav__socials {gap:15px;margin-left: 0px;}
    .en-nav__logo img { height: 45px; width:97px;margin-right:40px;}
  .en-nav__links > li > a { padding: 16px 40px;font-size: 14px; }
      .en-nav__links > li { border-bottom: none;}
      .en-nav__links { border-top: none;}
       
              .en-nav__dropdown li a { font-size: 14px;padding: 16px 24px 16px 54px;border-bottom:1px solid #575757;margin:0 20px; }
              .en-nav__dropdown li:last-child a { border-bottom:1px solid #575757; }
               .en-nav__dropdown li:first-child a { border-top:1px solid #575757; }
          .en-nav__links > li:first-child { border-top: 1px solid #7A7A7A; }

  

         
  }
`;

const AdorHeader = () => {
  const [mobileOpen, setMobileOpen]     = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (label) =>
    setOpenDropdown((prev) => (prev === label ? null : label));

  const toggleMobile = () => {
    setMobileOpen((prev) => {
      const next = !prev;
      document.body.style.overflow = next ? "hidden" : "";
      return next;
    });
  };

  const p = window.location.pathname;

  return (
    <>
      <style>{CSS}</style>

      <header className={`en-nav${mobileOpen ? " en-nav--open" : ""}`}>
        <nav className="en-nav__inner">

          <a href="/" className="en-nav__logo">
            <img src={EnergyLogo} alt="Energizing India Podcast" />
          </a>

          <button
            className={`en-nav__hamburger ${mobileOpen ? "open" : ""}`}
            onClick={toggleMobile}
            aria-label="Toggle navigation"
          >
            <span /><span /><span />
          </button>

          <ul className={`en-nav__links ${mobileOpen ? "open" : ""}`}>
            {NAV_LINKS.map((link) => (
              <li
                key={link.label}
                className={[
                  link.dropdown && openDropdown === link.label ? "open" : "",
                  isActive(link) ? "en-nav__active" : "",
                ].filter(Boolean).join(" ")}
              >
                <a
                  href={link.path}
                  onClick={
                    link.dropdown
                      ? (e) => { e.preventDefault(); toggleDropdown(link.label); }
                      : undefined
                  }
                >
                  {link.label}
                  {link.dropdown && (
                    <svg className="en-nav__chevron" viewBox="0 0 10 6" fill="none">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </a>

                {link.dropdown && (
                  <ul className="en-nav__dropdown">
                    <div className="en-nav__dropdown-inner">
                      {DROPDOWN_ITEMS.map((item) => (
                        <li key={item.label}>
                          <a
                            href={item.path}
                            className={
                              item.path !== "/" && p.startsWith(item.path)
                                ? "en-nav__dropdown-active"
                                : ""
                            }
                          >
                            {item.label}
                          </a>
                        </li>
                      ))}
                    </div>
                  </ul>
                )}

                <hr className="en-nav__divider" />
              </li>
            ))}
          </ul>

          <div className="en-nav__socials">
            {SOCIAL_LINKS.map((s) => (
              <a
                key={s.alt}
                href={s.href}
                className="en-nav__social-btn"
                aria-label={s.alt}
                target="_blank"
                rel="noreferrer"
              >
                <img src={s.icon} alt={s.alt} />
              </a>
            ))}
          </div>

        </nav>
      </header>
    </>
  );
};

export default AdorHeader;